module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.cec8170.woff2";